import React from 'react';
import PropTypes from 'prop-types';
import Button from "@material-ui/core/Button";
import './ResetPassword.css';
import Typography from '@material-ui/core/Typography';
import Modal from '@material-ui/core/Modal';
import { withStyles } from '@material-ui/core/styles';
import { ValidatorForm, TextValidator} from 'react-material-ui-form-validator';

function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

const styles = theme => ({
    paper: {
        position: 'absolute',
        width: theme.spacing.unit * 50,
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing.unit * 4,
        outline: 'none',
    },
});

class ResetPassword extends React.Component {
    constructor(props) {
        super(props);
        this.state = {email: '', open: false, successResetRequest: false};
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(event) {
        this.setState({
            email: event.target.value
        });
    }

    handleSubmit(event) {
        event.persist();
        console.log(this.state.email);
        fetch("/account-management/api/request-password-reset", {
            method: 'post',
            body: JSON.stringify({email: this.state.email}),
            headers: {'Content-Type': 'application/json'}
        })
            .then(
                (response) => {
                    let successResetRequest  = false;
                    if(200 === response.status) {
                        successResetRequest = true;
                        console.log('User is found');
                    } else if(404 === response.status) {
                        console.log('User is not found');
                    } else {
                        console.log('Unknown API response');
                    }

                    this.setState({
                        open: true,
                        successResetRequest
                    });
                },
                (error) => {
                    console.error(`Failed to create reset token`, error);
                }
            )
    }

    render() {
        const { classes } = this.props;

        return <ValidatorForm autoComplete="off" className={'reset-password-form'} onSubmit={this.handleSubmit}>
            <h3 className={'reset-password-label'}>Reset password</h3>
            <TextValidator
                id="email"
                label="Email"
                value={this.state.email}
                margin="normal"
                required={true}
                fullWidth={true}
                onChange={this.handleChange}
                validators={['required', 'isEmail']}
                errorMessages={['this field is required', 'email is not valid']}
            />
            <Button variant="outlined" className={'reset-password-button'} type="submit">
                Reset
            </Button>

            <Modal
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={this.state.open}
                >
                <div style={getModalStyle()} className={classes.paper}>
                    {this.state.successResetRequest && (
                        <Typography variant="subtitle1" id="simple-modal-description">
                            The details for reset password has been sent to the email: <b>{this.state.email}</b>.
                        </Typography>
                    )}
                    {!this.state.successResetRequest && (
                        <div>
                        <Typography variant="subtitle1" id="simple-modal-description">
                            Can't find the specified email address.
                        </Typography>
                        <Button variant="outlined" className={'reset-password-button'} onClick={() => { this.setState({open: false}) }}>
                            CLOSE
                        </Button>
                        </div>
                    )}
                </div>
            </Modal>

        </ValidatorForm>;
    }
}

ResetPassword.propTypes = {
    classes: PropTypes.object.isRequired,
};

const ResetPasswordWrapped = withStyles(styles)(ResetPassword);

export default ResetPasswordWrapped;
